<template>
    <div class="recommend_news f_left">
        <h2 class="recommend_title">推荐新闻</h2>
        <ul class="recommend_news_list">
            <li class="recommend_news_li" v-for="(item, index) in recommendList" :key="index" @click="seeNewsDetail(item)">
                <span class="recommend_news_image" :style="{backgroundImage: 'url(' + item.image + ')'}"></span>
                <div class="recommend_news_info">
                    <p class="recommend_news_title text_twoLine" v-html="item.title"></p>
                    <p class="recommend_news_views">
                        <i class="views_icon"></i>
                        <span class="views_num">{{item.hits}}</span>
                    </p>
                </div>
            </li>
        </ul>
    </div>
</template>
<script>
import { newsInterface } from "@/config/request";
export default {
    name: 'recommend',
    data() {
        return {
            recommendList: []
        }
    },
    methods: {
        // 获取数据
        getData() {
            newsInterface.newsRecommend({
                pageNo: 1,
                module: 'xwzx',
                type: 1
            }).then(res => {
                if(res.code == 1) {
                    let recommendArr = []
                    res.list.forEach(item => {
                        let imageArr = []
                        item.image = item.image.split('|')
                        item.image.forEach(subItem => {
                            if(subItem != "" && subItem.indexOf("http") != -1) {
                                imageArr.push(subItem)
                            }
                        })
                        recommendArr.push({
                            id: item.id,
                            image: imageArr[0],
                            hits: item.hits,
                            title: item.title
                        })
                    })
                    this.recommendList = recommendArr
                }
            })
        },
        // 查看新闻详情
        seeNewsDetail(item) {
            this.$router.push({
                path: '/newsDetail',
                query: {
                    articleId: item.id
                }
            })
            this.$emit('changeNewsId', item.id)
        }
    },
    created() {
        this.getData()
    },
}
</script>
<style scoped>
    @import './style/recommend.css';
</style>